<template>
    <div class="text-reduction" v-if="this.$data.content && length">
        <span v-if="length >= this.$data.content.length" class="text-nowrap" :class="textClass">
            {{this.$data.content}}
            <slot></slot>
        </span>
        <template v-if="length < this.$data.content.length">
            <span class="short-content text-nowrap" :class="textClass">{{this.$data.content.substr(0,length)}}...</span>
            <span class="full-content" :class="{nowrap: nowrap, 'right-align': right}" :style="{'background-color': bg}">{{this.$data.content}} <slot></slot></span>
        </template>
    </div>
</template>

<script>
    export default {
        name: "TextReduction",
        props: {
            nowrap: {
                type: Boolean,
                default: false
            },
            right: {
                type: Boolean,
                default: false
            },
            bg: {
                type: String,
                default: '#fff'
            },
            length: {
                type: Number,
                default: 40
            },
            text: {
                type: String,
                default: ''
            },
            textClass: null
        },
        data() {
            return {
                content: null
            }
        },
        created() {
            this.$data.content = this.$props.text;
        }
    }
</script>